
import {
  createContext,
  useCallback,
  useContext,
  useEffect,
  useState
} from "react";

import { translations, LOCALES } from "./translations";

const LanguageContext = createContext(null);

export function LanguageProvider({ children }) {
  const [lang, setLang] = useState(
    () => localStorage.getItem("kndla_lang") || "en"
  );

  useEffect(() => {
    localStorage.setItem("kndla_lang", lang);
  }, [lang]);

  const t = useCallback(
    (key, vars) => {
      let s =
        translations[lang]?.[key] ??
        translations.en[key] ??
        key;

      if (vars) {
        Object.entries(vars).forEach(([k, v]) => {
          s = s.replaceAll(`{${k}}`, String(v));
        });
      }

      return s;
    },
    [lang]
  );

  const locale = LOCALES[lang] || LOCALES.en;

  return (
    <LanguageContext.Provider
      value={{ lang, setLang, t, locale }}
    >
      {children}
    </LanguageContext.Provider>
  );
}

export function useLang() {
  return useContext(LanguageContext);
}
